<template>
  <v-container>
    <v-item-group mandatory v-model="itmGrpItem">
      <v-item v-for="(item, index) in stores" :key="index" :value="item.id">
        <template v-slot="{ active, toggle }">
          <v-btn :loading="changingStore" :outlined="!active" class="mr-2" color="primary" @click="toggle">
            <v-icon>mdi-home</v-icon>
            <span>{{ item.name }}</span>
          </v-btn>
        </template>
      </v-item>
    </v-item-group>
    <router-view></router-view>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import searchDelay from '@/extra-functions/searchDelay.extra'
import { useWatchEffect } from '../../../lib/utils'
import appAxios from '../../../extra-functions/axios.extra'
import LocalStore from '../../../lib/localStore'

const changeDelay = searchDelay()

const [watchEffect, clearWatchEffect] = useWatchEffect()
const localStore = new LocalStore()
const vItemGroupVars = () => {
  const prefix = 'itmGrp'
  return {
    [`${prefix}Item`]: 0,
  }
}

export default {
  name: 'vAdmin',
  data() {
    return {
      ...vItemGroupVars(),
      changingStore: false,

    }
  },
  created() {
    this.itmGrpItem = this.storeId
  },
  computed: {
    ...mapState({
      stores: state => state.branchLocation.list,
      storeId: state => state.settings.storeId,
      authToken: state => state.auth.token,
    }),
  },
  destroyed() {
    clearWatchEffect()
  },
  watch: {
    itmGrpItem(storeId) {
      if (this.storeId === storeId) return
      watchEffect((onCleanup) => {
        const controller = new AbortController()
        let timeout = null
        onCleanup(() => {
          clearTimeout(timeout)
          controller.abort()
        })
        timeout = setTimeout(() => {
          this.changeStore(storeId, controller)
        }, 100)
      }, 'storeChangeEffect')
    },
  },
  methods: {
    ...mapActions({
      setStore: 'settings/setStoreId',
    }),
    /**
     * Description
     * @param {string} storeId
     * @param {AbortController} controller
     * @returns {any}
     */
    async changeStore(storeId, controller) {
      try {
        this.changingStore = true
        this.$alertSwalLoading('changing store on server')
        await appAxios(this.authToken).post('/admin/users/store-change', { storeId }, {
          signal: controller.signal,
        })
        this.setStore(storeId)
        const localAuth = localStore.get('auth', null)
        if (!localAuth) throw new Error('auth is undefined')
        localStore.set({
          auth: {
            ...localAuth,
            storeId,
          },
        })
        this.$alertSwalSuccess('successfully changed store')
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong!!!')
      } finally {
        this.changingStore = false
      }
    },
  },
}
</script>
